import SarasErpApi from '../../../../../helper/SarasErpApi';

export const buildProdPlanProcessDetailRequest = (documentTypeId, documentId) => ({
    actionName: 'prodComp',
    actionId: 'show',
    actionType: 'planProcessDetail',
    dataList: {
        dtId: documentTypeId,
        dId: documentId
    }
});

export const fetchProdPlanProcessDetail = async (documentTypeId, documentId, onSuccessCallBack) => {
    const requestObject = buildProdPlanProcessDetailRequest(documentTypeId, documentId);
    const response = await SarasErpApi.post('core', requestObject);

    if (onSuccessCallBack) onSuccessCallBack(response, requestObject);

    return response;
};

export const buildProdPlanAuditDetailRequest = (documentTypeId, documentId) => ({
    actionName: 'prodComp',
    actionId: 'show',
    actionType: 'planAuditDetail',
    dataList: {
        dtId: documentTypeId,
        dId: documentId
    }
});

export const fetchProdPlanAuditDetail = async (documentTypeId, documentId, onSuccessCallBack) => {
    const requestObject = buildProdPlanAuditDetailRequest(documentTypeId, documentId);
    const response = await SarasErpApi.post('core', requestObject);

    if (onSuccessCallBack) onSuccessCallBack(response, requestObject);

    return response;
};

export const buildProdPlanOrderSheetDetailRequest = (documentTypeId, documentId) => ({
    actionName: 'prodComp',
    actionId: 'show',
    actionType: 'planOrderSheetDetail',
    dataList: {
        dtId: documentTypeId,
        dId: documentId
    }
});

export const fetchProdPlanOrderSheetDetail = async (documentTypeId, documentId, onSuccessCallBack) => {
    const requestObject = buildProdPlanOrderSheetDetailRequest(documentTypeId, documentId);
    const response = await SarasErpApi.post('core', requestObject);

    if (onSuccessCallBack) onSuccessCallBack(response, requestObject);

    return response;
};
